export { default as Event } from './Event'; // 事件件对象
export { default as Message } from './Message'; // 消息对象 7b38f887-e889-496c-b92d-d1739afa436e


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/message/index.ts